import React from 'react'
import './Loader.scss'

const Loader = () => {

    return (
        <div className={"loader"}>
            <div className={"loader__circles"}>
                <div className={"loader__circle"}>
                    <div className="loader__round loader__round--first"></div>
                </div>
                <div className={"loader__circle"}>
                    <div className="loader__round loader__round--second"></div>
                </div>
                <div className={"loader__circle"}>
                    <div className="loader__round loader__round--third"></div>
                </div>
            </div>
        </div>
    )
}

export default Loader